module.exports = __webpack_public_path__ + "static/media/stats.82446bc2.svg";